import { create } from 'zustand';

interface ToastState {
  message: string;
  visible: boolean;
  show: (message: string, ms?: number) => void;
}

let timer: ReturnType<typeof setTimeout>;

export const useToastStore = create<ToastState>((set) => ({
  message: '',
  visible: false,
  show: (message, ms = 3000) => {
    clearTimeout(timer);
    set({ message, visible: true });
    timer = setTimeout(() => set({ visible: false }), ms);
  },
}));

export const toast = (message: string, ms?: number) => {
  useToastStore.getState().show(message, ms);
};
